﻿/**
 * DATA — Implementação do Repositório (Adaptador Supabase)
 *
 * Thin wrapper sobre jukeboxService (shared) + RPCs de capability para
 * telas/playlist_itens (anon, escopadas por tela_id/playlist_id — ver
 * migration_zz_capability_rpc_telas.sql).
 */

import { supabase }          from '@/shared/lib/supabase';
import { fetchAllRpcPages } from '@/shared/lib/fetchAllRpcPages';
import { jukeboxService }   from '@/shared/services/jukeboxService';
import type { IJukeboxRepository, NovoPedidoDTO } from '../domain/ports/IJukeboxRepository';
import type { FilaJukebox } from '../domain/entities/FilaJukebox';
import type { Tela } from '@/shared/models/tela.model';
import type { PlaylistItem } from '@/shared/models/playlist.model';

export const jukeboxRepository: IJukeboxRepository = {

  inserirPedido(dto: NovoPedidoDTO): Promise<FilaJukebox> {
    return jukeboxService.inserirPedido({
      telaId:           dto.telaId,
      empresaId:        dto.empresaId,
      youtubeVideoId:   dto.youtubeVideoId,
      titulo:           dto.titulo,
      thumbnail:        dto.thumbnail,
      sessionId:        dto.sessionId,
      vibe:             dto.vibe,
      duracao_segundos: dto.duracao_segundos,
      clienteToken:     dto.clienteToken,
    });
  },

  listarAtivos:       (telaId) => jukeboxService.listarAtivos(telaId),
  buscarTocandoAgora: (telaId) => jukeboxService.buscarTocandoAgora(telaId),
  atualizarStatus:    (id, status, telaId) => jukeboxService.atualizarStatus(id, status, telaId),
  buscarCooldownStatus: (telaId) => jukeboxService.buscarCooldownStatus(telaId),
  limparFilaForaDaPlaylist: (telaId) => jukeboxService.limparFilaForaDaPlaylist(telaId),
  resolverTocandoDuplicados: (telaId) => jukeboxService.resolverTocandoDuplicados(telaId),

  async buscarTela(telaId: string): Promise<Tela> {
    const { data, error } = await supabase.rpc('player_buscar_tela' as never, { p_tela_id: telaId } as never);
    if (error) throw error;
    const rows = (data ?? []) as unknown as Tela[];
    if (rows.length === 0) throw new Error(`Tela ${telaId} não encontrada`);
    return rows[0];
  },

  async listarPlaylistItens(playlistId: string, telaId: string): Promise<PlaylistItem[]> {
    return fetchAllRpcPages<PlaylistItem>('jukebox_listar_playlist_itens_com_pedidos', {
      p_playlist_id: playlistId,
      p_tela_id:     telaId,
    });
  },
};
